import { Link } from "react-router-dom";
import { MessageCircle, Settings } from "lucide-react";

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || "5212713939941";

export const Footer = () => {
  return (
    <footer className="bg-[#0a0a0a] border-t border-white/5 py-10 px-4" data-testid="footer">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <span className="font-oswald font-bold text-2xl">
              <span className="text-[#00FF66]">O</span>
              <span className="text-white">Y</span>
              <span className="text-[#B026FF]">B</span>
            </span>
            <p className="text-[#A0A0A0] text-sm mt-2">
              Ropa original. Precios inteligentes.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="font-oswald font-semibold text-white mb-3 uppercase text-sm tracking-wide">Tienda</h4>
            <div className="space-y-2 text-sm text-[#A0A0A0]">
              <Link to="/categoria/hombre" className="block hover:text-[#00FF66] transition-colors">Hombre</Link>
              <Link to="/categoria/mujer" className="block hover:text-[#00FF66] transition-colors">Mujer</Link>
              <Link to="/categoria/gorras" className="block hover:text-[#00FF66] transition-colors">Gorras</Link>
              <Link to="/categoria/accesorios" className="block hover:text-[#00FF66] transition-colors">Accesorios</Link>
              <Link to="/categoria/zapatos" className="block hover:text-[#00FF66] transition-colors">Zapatos</Link>
              <Link to="/categoria/ofertas" className="block hover:text-[#00FF66] transition-colors">Liquidacion</Link>
              <Link to="/referidos" className="block text-[#00FF66] hover:underline transition-colors" data-testid="footer-referral-link">Comparte y Gana $50</Link>
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-oswald font-semibold text-white mb-3 uppercase text-sm tracking-wide">Contacto</h4>
            <p className="text-sm text-[#A0A0A0] mb-3">
              Recoge en persona. No hacemos envios.
            </p>
            <a
              href={`https://wa.me/${WHATSAPP_NUMBER}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white px-4 py-2 text-sm font-medium rounded-full hover:shadow-[0_0_12px_rgba(37,211,102,0.4)] transition-all duration-300"
              data-testid="footer-whatsapp-btn"
            >
              <MessageCircle className="w-4 h-4" />
              WhatsApp
            </a>
          </div>
        </div>

        <div className="border-t border-white/5 mt-8 pt-6 flex items-center justify-between">
          <span className="text-xs text-[#A0A0A0]/50">OYB 2024</span>
          <Link
            to="/login"
            className="flex items-center gap-1 text-xs text-[#A0A0A0]/50 hover:text-[#B026FF] transition-colors"
            data-testid="footer-admin-link"
          >
            <Settings className="w-3 h-3" />
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};
